import { render } from "./ItemContainerLeftRightSlotsComponent.vue?vue&type=template&id=412043ea"
const script = {}

import exportComponent from "C:\\wamp64_old\\www\\configurator_vue_version_3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__